import { firmAccountVerficationActions } from "./action";

const initialState = {
  accountNoVerify: null,
};

const accountNOVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case firmAccountVerficationActions.ACCOUNT_DETAILS_VERIFICATION_SUCCESS:
      return {
        ...state,
        // accountNoVerify: action.payload.data,
      };
    case firmAccountVerficationActions.ACCOUNT_DETAILS_VERIFICATION_ERROR:
      return {
        ...state,
        accountNoVerify: [],
      };

    default:
      return state;
  }
};

export default accountNOVerifyReducer;
